import { useMemo } from 'react';

import { CashCardType } from 'types';
import { Flex } from 'components/flex';
import { formatPrice } from 'utils/helpers';
import { InfoBlock } from 'components/info-block';

import * as Styles from './styles';
import { CashIcons, CashTitles } from './config';
import { CashCardProps, CashCardsProps } from './types';

export const CashCard = ({
  type,
  title,
  amount,
  customType,
}: CashCardProps) => (
  <InfoBlock>
    <Flex gap={16} alignItems="center">
      <Styles.CashIcon type={type}>
        {CashIcons[customType || type]}
      </Styles.CashIcon>
      <Flex gap={8} flexDirection="column">
        <Styles.CashTitle>
          {title || CashTitles[customType || type]}
        </Styles.CashTitle>
        <h3>{formatPrice(amount)}</h3>
      </Flex>
    </Flex>
  </InfoBlock>
);

export const CashCards = ({
  data,
  children,
  customType,
  showOnlyCash,
  customTotalCash,
}: CashCardsProps) => {
  const totalCash = useMemo(
    () =>
      typeof customTotalCash === 'number'
        ? customTotalCash
        : (data?.totalCollected || 0) - (data?.totalOut || 0) || 0,
    [data?.totalCollected, customTotalCash]
  );

  return (
    <Styles.Expenses>
      <CashCard
        amount={totalCash}
        customType={customType}
        type={CashCardType.Cash}
      />
      {!showOnlyCash && (
        <>
          {children}
          <CashCard type={CashCardType.Out} amount={data?.totalOut || 0} />
          <CashCard amount={data?.balance || 0} type={CashCardType.Balance} />
        </>
      )}
    </Styles.Expenses>
  );
};
